export default __webpack_public_path__ + "369c979a006c8a878a451a6d628bd5ba.svg";